import { useNavigate } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { ArrowRight } from 'lucide-react';
import Nav from '../../components/marketing/Nav';
import Footer from '../../components/marketing/Footer';
import { Button } from '../../components/ui/button';
import { FEATURES, HOW } from '../../lib/constants';

export default function Features() {
  const nav = useNavigate();
  return (
    <div className="min-h-screen bg-[#090A0F]">
      <Nav />
      <section className="max-w-7xl mx-auto px-5 pt-16 pb-10 relative grain">
        <div className="absolute inset-0 brand-glow pointer-events-none" />
        <div className="relative max-w-3xl">
          <div className="font-mono text-xs uppercase tracking-[0.25em] text-[#FF4D00] mb-4">Features</div>
          <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight leading-[1.05]">
            The whole video pipeline, driven by AI.
          </h1>
          <p className="text-slate-400 mt-5 text-lg">
            From ingestion to a finished YouTube upload — analysis, smart cuts, voice, music, captions and export.
          </p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 pb-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {FEATURES.map((f) => {
          const Ico = Icons[f.icon] || Icons.Sparkles;
          return (
            <div key={f.title} className="rounded-2xl border border-white/10 bg-[#12141D] p-6 hover:bg-[#161926] transition-colors">
              <div className="grid place-items-center w-11 h-11 rounded-xl bg-gradient-to-br from-[#FF4D00]/20 to-[#8B5CF6]/20 border border-white/10 mb-5">
                <Ico className="w-5 h-5 text-[#FF884D]" />
              </div>
              <div className="font-heading font-semibold text-lg">{f.title}</div>
              <div className="text-sm text-slate-400 mt-2 leading-relaxed">{f.desc}</div>
            </div>
          );
        })}
      </section>

      <section className="max-w-7xl mx-auto px-5 py-16">
        <div className="rounded-3xl border border-white/10 bg-[#0B0C12] p-8 sm:p-12">
          <h2 className="font-heading text-2xl sm:text-3xl font-bold mb-8">The AI workflow</h2>
          <div className="grid sm:grid-cols-3 lg:grid-cols-6 gap-4">
            {HOW.map((s) => (
              <div key={s.n} className="rounded-xl border border-white/10 bg-[#12141D] p-4">
                <div className="font-mono text-[#8B5CF6] text-sm">{s.n}</div>
                <div className="font-heading font-semibold mt-2">{s.t}</div>
                <div className="text-xs text-slate-400 mt-1">{s.d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 pb-24 text-center">
        <Button onClick={() => nav('/signup')} size="lg" className="rounded-full h-12 px-8 font-semibold">
          Start Creating Free <ArrowRight className="w-4 h-4 ml-1" />
        </Button>
      </section>
      <Footer />
    </div>
  );
}
